
    import '/mnt/src/components/GridView/index.md?watch=parent';
    export const demoIndex = {
  ids: ["gridview-demo-basic","gridview-demo-horizontal","gridview-demo-badge"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/GridView/index.md?type=demo')
};